<template>
    <div
        v-if="isVisible"
        class="card">
        <div class="card-body">
            <div
                v-for="question in question.children"
                :key="question.uuid">
                <KeepAlive>
                    <QuestionDecorator
                        v-bind="{...$props, ...$attrs}"
                        :question="question" />
                </KeepAlive>
            </div>
        </div>
    </div>
</template>

<script>
import questionMixin from "@/components/pages/registration/questions/questionMixin";
import {RuleBuilderEvaluator} from "@farbcodegmbh/amosweb-rulebuilder";

export default {
    name: "BlockQuestion",
    mixins: [questionMixin],

    computed: {
        // A group is only visible if it is visible by itself and at least one
        // of the questions inside it is visible.
        isVisible() {
            return this.isQuestionVisible(this.question) &&
                (this.question.children || []).some(child => this.isQuestionVisible(child))
        },
    },
    methods: {
        isQuestionVisible(question) {
            if (!question.visibilityConditions) {
                return true
            }
            const evaluator = new RuleBuilderEvaluator(
                {
                    ...this.getRegistrarQuestionsForRuleBuilderEvaluator,
                    ...this.registrarMode && this.getRegistrarRegistrationDateForRuleBuilder,
                    ...this.registrarMode && this.getRegistrationTypeForRuleBuilder,
                    ...!this.registrarMode && this.getParticipantQuestionsForRuleBuilderEvaluator,
                    ...!this.registrarMode && this.getParticipantDataForRuleBuilderEvaluator
                },
                false
            )
            return evaluator.evaluateRule(question.visibilityConditions)
        }
    }
}
</script>

<style scoped>

</style>
